import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { Button, DateField, FieldGroup } from '../../../../components';
import { useStore } from '../../../../store';
import User from '../../store/User';
import Bill from './store/Bill';

export default observer(function BillingWidget({ user }: { user?: User }) {
  const { billingStore } = useStore();
  const bill = useMemo(() => new Bill(user), [user]);

  function downloadBill() {
    return billingStore.downloadBill(bill);
  }

  return (
    <FieldGroup
      sx={{ alignItems: 'flex-end', display: 'flex', flexWrap: 'wrap' }}
    >
      <DateField
        errorText={bill.errors.startDate}
        label="Start date"
        name="startDate"
        onBlur={bill.handleBlur as any}
        onChange={bill.handleChange}
        value={bill.startDate}
      />
      <DateField
        errorText={bill.errors.startDate}
        label="End date"
        name="endDate"
        onBlur={bill.handleBlur as any}
        onChange={bill.handleChange}
        value={bill.endDate}
      />

      <Button
        disabled={!bill.isValid}
        disabledTooltip={bill.allErrorsAsStrings}
        icon="file-invoice-dollar"
        onClick={downloadBill}
        size="small"
        type="primary"
      >
        Generate bill
      </Button>
    </FieldGroup>
  );
});
